import { QueryKey } from '@tanstack/react-query';

/**
 * Create query keys
 * @param keys
 * @returns
 */
export const createQueryKeys = <T extends Record<string, string | string[]>>(
  keys: T,
): { [K in keyof T]: QueryKey } => {
  return Object.fromEntries(
    Object.entries(keys).map(([key, value]) => [key, [value]]),
  ) as unknown as { [K in keyof T]: QueryKey }; // Cast to unknown first
};
